import axios from "axios";

let instance = axios.create({
    withCredentials: true,
});

instance.interceptors.request.use(request => {
    request.headers.common['Accept']       = 'application/json';
    request.headers.common['Content-Type'] = 'application/json';
    request.headers.common['Access-Control-Allow-Origin'] = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_URL_LOCAL : process.env.VUE_APP_URL;//'https://community.fitme.lcl';
    request.headers.common['Access-Control-Allow-Headers'] = '*';
    request.headers.common['Access-Control-Allow-Credentials'] = true;
    return request;
});

instance.interceptors.response.use(
	response => { return response; },
	error => {
        if (error.response.status === 401) {
            // localStorage.removeItem('user');
        }
        return Promise.reject(error);
    }
);

export default instance;
